
import { useSelector } from "react-redux"

import { AppBar, Container, Toolbar, Box, List, ListItem } from "@mui/material"

import { DialogTokenExpired } from "../dialogs/DialogTokenExpired"

import { ListItemBandeja } from "./listitem/ListItemBandeja"
import { ListItemNuevo } from "./listitem/ListItemNuevo"
import { ListItemBuscar } from "./listitem/ListItemBuscar"
import { ListItemConsultas } from "./listitem/ListItemConsultas"
import { ListItemPerfil } from "./listitem/ListItemPerfil "
import { ListItemCatalogos } from "./listitem/ListItemCatalogos"

import { RootState } from "../store"

export const NavBar = () => {
    
    const { roles, administrador } = useSelector( ( state: RootState ) => state.auth );

    return (
        <>
            <DialogTokenExpired />
        
            <AppBar position="fixed" style={{ boxShadow: 'none', backgroundColor: 'white', borderBottom: '3px solid rgba(10, 25, 45, 0.8)' }}>

                <Container maxWidth="xl" sx={{ backgroundColor: 'white' }}>

                    <Toolbar 
                        disableGutters
                        sx={{ backgroundColor: 'white', height: 85 }}
                    >
                    
                        <Box sx={{ textAlign: 'start' }}>               

                            <img 
                                style={{ height: 60 }}
                                src={ process.env.PUBLIC_URL + "/assets/logo-saji.png"}
                                alt='logo'
                            />                       
                            
                        </Box>  

                        <Box sx={{ flex: 1 }}>

                            <List component="nav">
                            
                                <ListItem component="div" sx={{ textAlign: 'center' }}>  
                                    
                                    {
                                        !administrador && <ListItemBandeja />        
                                    }                                

                                    {
                                       roles?.ModuloNuevoProceso && <ListItemNuevo />   
                                    }                                   

                                    {
                                       roles?.ModuloBusqueda && <ListItemBuscar />     
                                    }  

                                    {
                                       roles?.ModuloConsultas && <ListItemConsultas />  
                                    }    

                                    {
                                       roles?.ModuloCatalogos && <ListItemCatalogos />   
                                    }                        

                                </ListItem>

                            </List>

                        </Box>                  

                        <Box sx={{ display: 'flex' }}>
                            
                            <List component="nav">

                                <ListItemPerfil /> 

                            </List>

                        </Box>                  

                    </Toolbar>

                </Container>

            </AppBar>
        </>
    )
}